import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {StackItem} from "@/packages/stack-router/class/StackItem";
import {StackItemState} from "@/packages/stack-router/types";

export type StackComponentProps = {
    stackItemId?: string | undefined
    stackItemIndex?: number
}

export function useStackComponent<TState extends StackItemState = StackItemState>(props: StackComponentProps) {

    const {stackItemId, stackItemIndex} = props
    let stackItem: StackItem | undefined
    let stackItemState: TState = {} as TState

    let bind: any = {}

    if (stackItemId) {
        const stackRouter = useStackRouter()
        stackItem = stackRouter.getItemById(stackItemId)
        bind = {
            ...bind,
            stackItemId,
            stackItemIndex
        }
        stackItemState = stackItem?.state
    }

    return {
        bind,
        stackItem,
        stackItemState
    }
}

export function useStackComponentWithStandalone<TStackProps extends StackComponentProps = StackComponentProps, TNoStackProps = any>(
    props: StackComponentProps,
    stackProps: Omit<TStackProps, 'stackItemId'> & {
        is: any
    },
    nostackProps?: TNoStackProps & {
        is: any
    }
) {

    const stackItemId = props.stackItemId
    const stackItemIndex = props.stackItemIndex

    let bind: {
        stackItemId: string
        stackItemIndex: number
        is?: any
    } = {
        stackItemId: stackItemId || '',
        stackItemIndex: stackItemIndex || 0
    }

    if (stackItemId) {
        if (stackProps) {
            bind = {
                ...bind,
                ...stackProps
            }
        }
    } else {
        if (nostackProps) {
            bind = {
                ...bind,
                ...nostackProps
            }
        }
    }

    return {
        bind
    }
}
